import { APIMeta } from "./base";

export enum DebtStatus {
  PENDING = "pending", // No payment, on time
  PARTIALLY_PAID = "partially_paid", // Some payment, on time
  PAID = "paid", // Fully paid
  OVERDUE = "overdue", // Past due date, not fully paid
  CANCELLED = "cancelled", // Cancelled
}

export enum DebtType {
  RECEIVABLE = "receivable",
  PAYABLE = "payable",
}

export interface APIMultiDebtsResponse {
  debts: APIDebt[];
  meta: APIMeta;
}

export interface MultiDebtsResponse {
  debts: Debt[];
  meta: APIMeta;
}

export type APIDebt = {
  contact_id: number;
  contact: {
    name: string;
  };
  original_amount: number;
  remaining_amount: number;
  due_date: string;
  emitted_date: string;
  invoice_number: string;
  description: string;
  id: number;
  company_id: number;
  org_id: number;
  status: DebtStatus;
  created_at: string;
  updated_at: string;
  type: DebtType;
  tags?: string[];
  branch?: {
    id: number;
    name: string;
  };
  tax?: number;
  category?: {
    id: number;
    name: string;
    group?: {
      id: number;
      name: string;
    };
  };
  department?: {
    id: number;
    name: string;
  };
  images?: Array<{
    id: number;
    image_url: string;
    presigned_url?: string;
    content_type?: string;
  }>;
  approval_status: string;
};

export type Debt = {
  contactId: number;
  contactName: string;
  originalAmount: number;
  remainingAmount: number;
  emittedDate: string;
  dueDate: string;
  description: string;
  invoiceNumber: string;
  id: number;
  companyId: number;
  orgId: number;
  status: DebtStatus;
  createdAt: string;
  updatedAt: string;
  type: DebtType;
  tags?: string[];
  branchName?: string;
  branch?: {
    id: number;
    name: string;
  };
  tax?: number;
  category?: {
    id: number;
    name: string;
    group?: {
      id: number;
      name: string;
    };
  };
  department?: {
    id: number;
    name: string;
  };
  images?: Array<{
    id: number;
    image_url: string;
    presigned_url: string;
    content_type: string;
  }>;
  approvalStatus: string;
};
